<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
      clearable
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemAddonKind} from "@/modules/redactor/models/item-addon/ItemAddonKind";

export default {
  name: "r-item-addon-kind",
  props: {
    model: VueTypes.instanceOf(ItemAddonKind),
    label: VueTypes.string.def("Addon Kind:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemAddonKind.getValues();
    }
  }
}
</script>